"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGameReducer = void 0;
const models_1 = require("@creature-chess/models");
const toolkit_1 = require("@reduxjs/toolkit");
const redux_1 = require("~/plugins/redux");
const registry_1 = require("~/plugins/registry");
const announcements_1 = require("./announcements");
const localPlayer_1 = require("./localPlayer");
const network_1 = require("./network");
const playerReducers_1 = require("./playerReducers");
const state_1 = require("./players/state");
const quickChat_1 = require("./quickChat");
const ui_1 = require("./ui");
const initialRoundInfo = {
    round: 1,
    phase: models_1.GamePhase.PREPARING,
    phaseStartedAtSeconds: 0,
};
const roundInfoReducer = (state = initialRoundInfo, action) => {
    if (action.type !== models_1.GameEvents.gamePhaseStartedEvent.type ||
        !action.payload) {
        return state;
    }
    const { phase, startedAt, round } = action.payload;
    return Object.assign(Object.assign(Object.assign({}, state), { phase, phaseStartedAtSeconds: Math.floor(startedAt) }), (round ? { round } : {}));
};
const createGameReducer = () => (0, toolkit_1.combineReducers)(Object.assign(Object.assign({}, playerReducers_1.playerReducers), { localPlayer: localPlayer_1.localPlayerReducer, roundInfo: roundInfoReducer, players: state_1.playersReducer, quickChat: quickChat_1.quickChatReducer, announcements: announcements_1.announcementsReducer, ui: ui_1.uiReducer, plugins: (0, redux_1.buildPluginsReducer)(registry_1.pluginRegistry), network: network_1.networkReducer }));
exports.createGameReducer = createGameReducer;
